import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setUserToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
      const idToken = params.get("id_token");
      const sessionId = params.get("session_id");
      try {
        let r;
        if (idToken) {
          // New: our own Google OAuth client
          r = await api.post("/auth/google", { id_token: idToken });
        } else if (sessionId) {
          // Legacy: Emergent session (keep until fully migrated)
          r = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        } else {
          nav("/"); return;
        }
        setUserToken(r.data.session_token);
        setUser(r.data);
        const next = localStorage.getItem("c4t_after_login") || "/";
        localStorage.removeItem("c4t_after_login");
        nav(next, { replace: true });
      } catch {
        nav("/", { replace: true });
      }
    };
    run();
  }, [nav, setUser]);

  return (
    <div className="max-w-md mx-auto p-12 text-center" data-testid="auth-callback">
      <p className="text-[#455A64] font-['Fredoka'] text-lg">Signing you in...</p>
    </div>
  );
}
